import { render, staticRenderFns } from "./PersonaMoral.vue?vue&type=template&id=709efd98"
import script from "./PersonaMoral.vue?vue&type=script&lang=js"
export * from "./PersonaMoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports